import { createRoutine } from 'redux-saga-routines';
import {
  GET_STAFF,
  UPDATE_STAFF_ACTION,
  GET_STAFF_SUGGESTIONS_ACTION,
  ADD_STAFF_ACTION,
  DELETE_STAFF_ACTION,
  GET_STAFF_PROFFESSIONS,
} from './constants';

export const getStaffAction = createRoutine(GET_STAFF);
export const updateStaffAction = createRoutine(UPDATE_STAFF_ACTION);
export const deleteStaffAction = createRoutine(DELETE_STAFF_ACTION);
export const getStaffSuggestionsAction = createRoutine(GET_STAFF_SUGGESTIONS_ACTION);
export const addStaffAction = createRoutine(ADD_STAFF_ACTION);
export const getStaffProfessionsAction = createRoutine(GET_STAFF_PROFFESSIONS);
